function cov_k76m70xqm() {
  var path = "/app/src/components/installments-input/index.ts";
  var hash = "56596f37e545101ff746d8024e622f7eb9b83086";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/installments-input/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "56596f37e545101ff746d8024e622f7eb9b83086"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_k76m70xqm = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_k76m70xqm();
export { InstallmentsInput } from './installments-input';